import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
  const pxToRem = (px: number): string => `${px / 16}rem`;

  return {
    container: {
      padding: `${pxToRem(54)} ${pxToRem(65)} ${pxToRem(38)}`,
    },
  };
});

export default useStyles;
